export default __webpack_public_path__ + "static/media/roadmap.0dd5a03e.svg";